import { User } from "../../../../models/request/user";
import { Shift } from "../../../shift/services/shift-service"
import { ATTENDANCE_MODE } from "../../../../constants/status";

// Lịch làm việc cố định (NV mode FIXED) hôm đang xem — mirror hrm `DetailWorkScheduleResponse`.
// `is_working = false` = hôm đó là ngày nghỉ tuần theo lịch (khác `null` = chưa cấu hình gì).
export class WorkSchedule {
    name: string = '';
    start_time: string = '';
    end_time: string = '';
    is_working: boolean = false;

    constructor(data?: Partial<WorkSchedule>) {
        Object.assign(this, data);
    }
}

// Mirror của hrm ATTENDANCE_GRID_CELL_STATUS (attendance-grid.response.ts) — 2 codebase tách biệt,
// đổi giá trị bên hrm PHẢI đổi khớp ở đây.
export enum ATTENDANCE_GRID_CELL_STATUS {
    ON_TIME = 1,
    LATE_OR_EARLY = 2,
    ABSENT_UNPERMITTED = 3,
    ABSENT_PERMITTED = 4,
    DAY_OFF = 5,
    NOT_APPLICABLE = 6,
    PENDING_TODAY = 7,
    FUTURE = 8,
    // NV "Không chấm công" — hệ số công cron đã chốt (daily_payrolls; tài xế/kiểm đếm tính theo số đơn).
    NO_ATTENDANCE_FULL_DAY = 9,
    NO_ATTENDANCE_HALF_DAY = 10,
    NO_ATTENDANCE_NO_PAY = 11,
}

export interface AttendanceGridCell {
    status: ATTENDANCE_GRID_CELL_STATUS;
    note: string | null;
    minutes_late: number;
    minutes_early: number;
    /** Hệ số công đã chốt (daily_payrolls: 0 / 0.5 / 1). null = chưa có → hiện ký hiệu theo `status`. */
    work_day_coefficient?: number | null;
}

export interface AttendanceGridRow {
    employee: User;
    attendance_mode: ATTENDANCE_MODE;
    days: Record<string, AttendanceGridCell>;
    total_work_days?: number;
}

export class AttendanceDailySession {

    date: string = '';
    employee: User = new User();
    total_sessions: number = 0;
    completed_sessions: number = 0;
    active_sessions: number = 0;
    total_work_hours: number = 0;
    total_work_minutes: number = 0;
    total_overtime_hours: number = 0;
    total_work_day_coefficient: number = 0;
    sessions: AttendanceSession[] = [];

    constructor(data: Partial<AttendanceDailySession>) {
        Object.assign(this, data);
    }
}

export class AttendanceSession {

    id: string = '';
    check_in_at: string = '';
    check_out_at: string = '';
    check_in_status: number = 0;
    check_out_status: number = 0;
    minutes_late: number = 0;
    minutes_early: number = 0;
    work_hours: number = 0;
    overtime_hours: number = 0;
    address_check_in: string = '';
    address_check_out: string = '';
    session_status: string = '';
    work_day_coefficient: number = 0;
    note: string = '';

    constructor(data: Partial<AttendanceSession>) {
        Object.assign(this, data);
    }
}

export class AttendanceRecord {

    log_company_id: number = 0;
    created_at: string = '';
    updated_at: string = '';
    id: string = '';
    employee_id: number = 0;
    date: string = '';
    check_in_at: string = '';
    check_out_at: string = '';
    work_hours: number = 0;
    overtime_hours: number = 0;
    location_in_status: string = '';
    location_out_status: string = '';
    check_in_device_id: string = '';
    check_out_device_id: string = '';
    check_in_status: number = 0;
    check_out_status: number = 0;
    absence_type: number = 0;
    minutes_late: number = 0;
    minutes_early: number = 0;
    employee_last_modified_by_id: number = 0;
    work_day_coefficient: number = 0;
    note: string = '';
    avatar_check_in: string = '';
    avatar_check_out: string = '';
    address_check_in: string = '';
    address_check_out: string = '';
    check_in_scope: number = 0;
    check_out_scope: number = 0;
    additional_info: any = {};
    employee: User = new User();
    // working_schedule: CompanySettingWorkingSchedules = new CompanySettingWorkingSchedules();
    shift: Shift = {} as Shift;
    attendance_mode: ATTENDANCE_MODE = ATTENDANCE_MODE.SHIFT;
    work_schedule: WorkSchedule | null = null;

    constructor(data?: Partial<AttendanceRecord>) {
        Object.assign(this, data);
    }
}